import React from 'react';
import { Building2 } from 'lucide-react';
import './CompanyCell.css';

type Props = {
  name?: string | null;
  className?: string;
};

/** Chip de empresa destacado (servicios + mantenedoras). */
const CompanyCell: React.FC<Props> = ({ name, className = '' }) => {
  const label = (name ?? '').trim();
  if (!label) {
    return (
      <span className={`company-cell company-cell--empty ${className}`.trim()}>
        <span className="company-cell__icon" aria-hidden>
          <Building2 size={14} strokeWidth={2.25} />
        </span>
        <span className="company-cell__name">Sin empresa</span>
      </span>
    );
  }

  return (
    <span className={`company-cell ${className}`.trim()} title={label}>
      <span className="company-cell__icon" aria-hidden>
        <Building2 size={14} strokeWidth={2.25} />
      </span>
      <span className="company-cell__name">{label}</span>
    </span>
  );
};

export default CompanyCell;
